// tslint:disable: cyclomatic-complexity
import * as React from 'react';
import Styled, { css, SimpleInterpolation } from 'styled-components';

import { media } from '../../../lib/StyledComponents/StyledComponents';
import SVGIcon, { SVGIconStyleWrapper } from '../../Icon/SVGIcon';
import { cssDeclaration, VALID_COLOR_DATA } from '../Utils';

import { IButtonIcon } from './Button';

interface IButtonChildCommonProps {
  iconProps?: IButtonIcon;
  disabled?: boolean;
  variant: string;
}

const StyledBeforeIcon = css<IButtonChildCommonProps>`
  ${({ theme: { themeTwo }, iconProps, disabled, variant }) => {
    const { button } = themeTwo;
    const buttonVariant = button.overrides[variant];
    /* tslint:disable-next-line: no-non-null-assertion */
    const hasThemeIconStyles = !!(buttonVariant.base && buttonVariant.base!.icons);
    const beforeIconStyles = iconProps && iconProps.before && iconProps.before;

    return css`
      ${beforeIconStyles && css`
        &:first-of-type {
          display: block;
          width: ${beforeIconStyles.width && themeTwo.global.edgeSize[beforeIconStyles.width] || beforeIconStyles.width};
          height: ${beforeIconStyles.height && themeTwo.global.edgeSize[beforeIconStyles.height] || beforeIconStyles.height};

          /* color */ ${beforeIconStyles.color && cssDeclaration(themeTwo, 'color', beforeIconStyles.color)};
          /* margin */ ${beforeIconStyles.margin && cssDeclaration(themeTwo, 'margin', beforeIconStyles.margin)};

          svg {
            width: ${beforeIconStyles.width && themeTwo.global.edgeSize[beforeIconStyles.width] || beforeIconStyles.width};
            height: ${beforeIconStyles.height && themeTwo.global.edgeSize[beforeIconStyles.height] || beforeIconStyles.height};
          }

          ${disabled && css`
              /* fill */
              ${hasThemeIconStyles ?
                cssDeclaration(themeTwo, 'fill', beforeIconStyles.color) :
                // fall back for no themed icons
                buttonVariant.state.disabled.font &&
                  cssDeclaration(themeTwo, 'fill', buttonVariant.state.disabled.font.color as VALID_COLOR_DATA)
              };
          `}
        }
      `}
    `;
  }}
`;

const StyledAfterIcon = css<IButtonChildCommonProps>`
  ${({ theme: { themeTwo }, iconProps, disabled, variant }) => {
    const { button } = themeTwo;
    const buttonVariant = button.overrides[variant];
    /* tslint:disable-next-line: no-non-null-assertion */
    const hasThemeIconStyles = !!(buttonVariant.base && buttonVariant.base!.icons);
    const afterIconStyles = iconProps && iconProps.after && iconProps.after;

    return css`
      ${afterIconStyles && css`
        &:last-of-type {
          display: block;
          width: ${afterIconStyles.width && themeTwo.global.edgeSize[afterIconStyles.width] || afterIconStyles.width};
          height: ${afterIconStyles.height && themeTwo.global.edgeSize[afterIconStyles.height] || afterIconStyles.height};

          /* color */ ${afterIconStyles.color && cssDeclaration(themeTwo, 'color', afterIconStyles.color)};
          /* margin */ ${afterIconStyles.margin && cssDeclaration(themeTwo, 'margin', afterIconStyles.margin)};

          svg {
            width: ${afterIconStyles.width && themeTwo.global.edgeSize[afterIconStyles.width] || afterIconStyles.width};
            height: ${afterIconStyles.height && themeTwo.global.edgeSize[afterIconStyles.height] || afterIconStyles.height};
          }

          ${disabled && css`
              /* fill */
              ${hasThemeIconStyles ?
                cssDeclaration(themeTwo, 'fill', afterIconStyles.color) :
                // fall back for no themed icons
                buttonVariant.state.disabled.font &&
                  cssDeclaration(themeTwo, 'fill', buttonVariant.state.disabled.font.color as VALID_COLOR_DATA)
              };
          `}
        }
      `}
    `;
  }}
`;

const IconWrapper = Styled.span<IButtonChildCommonProps>`
  ${SVGIconStyleWrapper} {
    flex-shrink: 0;


    ${({ theme: { themeTwo }}) => {
      const { button } = themeTwo;
      const hideOnMobile = button.base && button.base.icons && button.base.icons.mobileHidden;

      return css`
        ${!hideOnMobile ?
          css`
            ${StyledBeforeIcon}
            ${StyledAfterIcon}
          `
          :
          css`
            &:last-of-type,
            &:first-of-type {
              display: none;
            }
          `
        }

        ${media.small`
          ${StyledBeforeIcon as SimpleInterpolation};
          ${StyledAfterIcon as SimpleInterpolation};
        `}
      `;
    }}
  }
`;

const ButtonChildWrapper: React.FC<IButtonChildCommonProps> = ({ children, disabled, iconProps, variant }) => (
  <>
    {iconProps ?
      <IconWrapper iconProps={iconProps} disabled={disabled} variant={variant}>
        {iconProps.before &&
          <SVGIcon icon={iconProps.before.icon} rotate={iconProps.before.rotate} />
        }

        {children}

        {iconProps.after &&
          <SVGIcon icon={iconProps.after.icon} rotate={iconProps.after.rotate} />
        }
      </IconWrapper>
      :
      <span>{children}</span>
    }
  </>
);

export default ButtonChildWrapper;
